import { render, staticRenderFns } from "./Seccion_resumen.vue?vue&type=template&id=d4f7fd9a&lang=pug&"
import script from "./Seccion_resumen.vue?vue&type=script&lang=js&"
export * from "./Seccion_resumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports